<template>
  <div class="wrapper">
    <Header class="header" data-title="장바구니" :type="'home'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="cart">
        <!-- pageTab (s) -->
        <ul class="tabList pageTab">
          <li class="on">
            렌탈
            <span class="normal">
              (
              <span v-text="rentalCount"></span>
              )
            </span>
          </li>
          <li @click="$router.replace('/cart/payment')">
            구매
            <span class="normal">
              (
              <span v-text="purchaseCount"></span>
              )
            </span>
          </li>
          <!-- li @click="$router.replace('/cart/delivery')">
            정기배송
            <span class="normal">
              (
              <span v-text="deliveryCount"></span>
              )
            </span>
          </li -->
        </ul>
        <!-- pageTab (e) -->

        <section class="full hr">
          <div class="banner">
            <ul class="slideList">
              <li>
                <a>
                  <span class="img">
                    <img :src="cponBannerUrl" alt="" />
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </section>

        <section class="full hr mg0" v-if="productList.length > 0">
          <div class="sortArea">
            <div class="lcont">
              <span class="singleIpt">
                <input type="checkbox" class="ipt chkAll" name="mod_hr_1" id="mod_hr_1_0" v-model="chkAll" />
                <label for="mod_hr_1_0">전체선택</label>
              </span>
            </div>
            <div class="rcont">
              <button type="button" class="btn_s s" @click="productListDelete">
                <span>선택삭제</span>
              </button>
            </div>
          </div>

          <ul class="prdList line hr">
            <li v-for="(item, index) in productList" :key="index">
              <span class="singleIpt">
                <input type="checkbox" class="ipt" name="termsSub" :id="index" :value="index" v-model="chkSub" />
                <label :for="index">
                  <span class="blind">해당열 상품</span>
                  선택
                </label>
              </span>
              <button type="button" class="delBtn" @click="productDelete(item)">
                <span class="blind">해당열 상품 삭제</span>
              </button>
              <div class="block">
                <div
                  class="prdItem m"
                  @click="
                    item.productInfo.product.productIndex != '0' && item.productInfo.productDetail.discntFlag != 'Y'
                      ? $router.push('/product/category/detail/' + item.productInfo.product.productIndex)
                      : ''
                  "
                >
                  <div class="imgArea">
                    <span class="img imgCover">
                      <img :src="item.productInfo.product.thumbnail" :alt="item.productInfo.product.displayName" />
                    </span>
                  </div>
                  <div class="infoArea">
                    <div class="tit row2">
                      <span v-text="item.productInfo.product.productName"></span>
                    </div>
                    <div class="txtItem">
                      <span v-text="item.productInfo.product.model"></span>
                    </div>
                    <div class="price">
                      <span class="money">
                        월 렌탈료
                        <em>{{ getConvertPrice(item.selectedOption.rentalAmount) }}</em>
                        원
                      </span>
                    </div>
                  </div>
                </div>
                <div class="selectedOpt">
                  <button type="button" class="btn_s round s" @click="optionPopupOpen(item)" :disabled="!checkOption(item.productInfo)">
                    <span>옵션변경</span>
                  </button>
                  <div class="txtOpt">
                    <div class="opt">
                      <span class="item" v-if="isOptionsExist(item.productInfo)">옵션</span>
                      <span class="val">
                        <span v-if="item.selectedOption.colorName">색상 : {{ item.selectedOption.colorName }}</span>
                        <span v-if="item.selectedOption.checkTypeNm && item.selectedOption.checkType != 'RREG0001'">
                          / 점검: {{ item.selectedOption.checkTypeNm }}
                        </span>
                        <span v-if="item.selectedOption.instTypeNm && item.selectedOption.instType != 'RNOR0001'">
                          / 설치: {{ item.selectedOption.instTypeNm }}
                        </span>
                        <span v-if="item.selectedOption.optionCodeNm1 && item.selectedOption.optionCode1 != 'FM060001'">
                          / {{ item.selectedOption.optionCodeNm1 }}
                        </span>
                        <span v-if="item.selectedOption.optionCodeNm2 && item.selectedOption.optionCode2 != 'FM060001'">
                          / {{ item.selectedOption.optionCodeNm2 }}
                        </span>
                        <span v-if="item.selectedOption.optionCodeNm3 && item.selectedOption.optionCode3 != 'FM060001'">
                          / {{ item.selectedOption.optionCodeNm3 }}
                        </span>
                      </span>
                    </div>
                    <div class="opt">
                      <span class="item">렌탈기간</span>
                      <span class="val" v-text="item.selectedOption.rentalPeriodNm"></span>
                    </div>
                  </div>
                </div>
                <div class="prdPrice line">
                  <div class="row">
                    <span class="info">렌탈료</span>
                    <div class="val">
                      <span class="price m pointC6">
                        월
                        <span class="money" v-text="getConvertPrice(item.selectedOption.rentalAmount)"></span>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info pointC1">예상 혜택가</span>
                    <div class="val">
                      <span class="price pointC1">
                        월
                        <em class="money" v-text="getConvertPrice(item.selectedOption.cardDcAmount)"></em>
                        원
                      </span>
                    </div>
                  </div>
                </div>
                <p class="txtXS pointC6 mt5 ar">
                  제휴카드 청구할인 혜택가 ({{ item.selectedOption.rentalPeriodNm }} 총
                  <template v-if="item.selectedOption.rentalPeriod">
                    {{
                      ((item.selectedOption.rentalAmount - item.selectedOption.cardDcAmount) *
                        item.selectedOption.rentalPeriod.substring(
                          item.selectedOption.rentalPeriod.length - 2,
                          item.selectedOption.rentalPeriod.length,
                        ))
                        | currency
                    }}원 할인)
                  </template>
                </p>
              </div>

              <div class="btnArea">
                <button type="button" class="btn_p m" @click="goRental(item, index)" :id="'rentalBtn' + index">렌탈하기</button>
              </div>

              <div class="shadowTip" v-bind:id="'tooltip' + index" v-if="false">
                <div class="blind">
                  <div class="toolTip s black col_w top">
                    <a role="button" @click="couponPopupOpen(item.productInfo.product.productCode, item.downLoadableCponCount, index)">
                      상품에 적용 가능한 쿠폰이 있어요!
                    </a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </section>

        <CommonBanner v-if="productList.length > 0"></CommonBanner>

        <section class="hr noItem" v-if="productList.length == 0">
          <div class="resultMsg noItem">
            <p class="copy">장바구니에 담긴 상품이 없습니다.</p>
            <!-- TODO 경로 확인 -->
            <button type="button" class="btn_l m" @click="$router.push('/product/category/9')">홈쇼핑 히트템 보러가기</button>
          </div>
        </section>

        <section class="hr noItem" v-if="productList.length == 0">
          <div class="titArea">
            <h2 class="titH4">이런 상품은 어떠세요?</h2>
          </div>
          <div class="slide goodsList" id="prd1">
            <ul class="slideList">
              <li v-for="(product, index) in popProductList" :key="index">
                <a
                  @click="
                    product.productIndex != '0' && product.discntFlag != 'Y' ? $router.push('/product/category/detail/' + product.productIndex) : ''
                  "
                  class="block"
                >
                  <span class="img imgCover">
                    <img :src="product.thumbnail" alt="" />
                  </span>
                  <em class="tit row2">{{ product.displayName }}</em>
                  <p class="desc">{{ product.model }}</p>
                  <p class="price">
                    월
                    <span class="money">{{ product.cardDCrentalAmount | currency }}</span>
                    원
                    <span class="txtXXS">/제휴카드가</span>
                  </p>
                </a>
              </li>
            </ul>
            <div class="swiper-scrollbar"></div>
          </div>
        </section>
        <OptionPop v-if="optionPopFlag" @close="optionPopupClose" @selectOption="optionSelect" :propsObj="productInfo" :flag="'rental'"></OptionPop>
        <CouponPop
          v-if="couponPopFlag"
          @close="couponPopupClose"
          @selectCoupon="selectCoupon"
          @allCoupon="allCoupon"
          :propsProductCode="productCode"
          :propsCouponType="couponType"
          :propsIndex="idx"
        ></CouponPop>
        <MessagePop v-if="messagePop" @close="messagePop = false">
          <p v-html="msg"></p>
        </MessagePop>
        <ProgressBar ref="progress"></ProgressBar>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>
<script>
import * as customjs from '@/../static/js/m.front.js';
import OptionPop from '@/components/popup/OptionPop';
import CouponPop from '@/components/popup/CouponPop';
import ApiService from '@/common/api.service';
import { convertPrice } from '@/common/common.filter';
import CommonBanner from '@/components/banner/CommonBanner';
import { DELETE_COMPLETE, OPTION_UPDATE, COUPON_SELECT, ALL_COUPON_SELECT } from '@/store/message.type.js';
import MessagePop from '@/components/popup/MessagePop';
import ProgressBar from '@/views/app/comm/ProgressBar';
import $ from 'jquery';

export default {
  name: 'CartRental',
  components: {
    OptionPop,
    CouponPop,
    CommonBanner,
    MessagePop,
    ProgressBar,
  },
  data: function () {
    return {
      productList: [],
      rentalCount: 0,
      purchaseCount: 0,
      deliveryCount: 0,
      cponBannerUrl: '',

      chkAll: false,
      chkSub: [],
      chkAllFlag: true,

      popProductList: [], // 인기상품

      // 팝업 관련
      optionPopFlag: null,
      couponPopFlag: null,
      productInfo: null,
      productCode: null,
      msg: null,
      messagePop: null,
      couponType: 'CPAP0001',
      couponCheck: [],
      idx: 0,
    };
  },
  watch: {
    chkAll() {
      if (this.chkAll) {
        this.chkSub = [];
        this.chkAllFlag = true;
        const array_termsSub = document.getElementsByName('termsSub');
        for (let i = 0; i < array_termsSub.length; i++) {
          this.chkSub.push(array_termsSub[i].value);
        }
      } else if (this.chkAllFlag) {
        this.chkSub = [];
      }

      this.checkBoxWork();
    },
    chkSub() {
      this.checkBoxWork();
    },
  },
  updated() {
    customjs.slideInit('#prd1', 0, false, 300, false, 'auto', 8);
    customjs.tooltipInit();
  },
  mounted() {
    customjs.slideInit('#prd1', 0, false, 300, false, 'auto', 8);

    this.selectBasketList();

    // 인기 상품 조회
    ApiService.service('GET', '/product/popular/main/MPTP0001')
      .then(({ data }) => {
        if (data.result) {
          this.popProductList = data.result;
        }
      })
      .catch(({ response }) => {
        console.log(response);
      });
  },
  methods: {
    selectBasketList: function () {
      this.$refs.progress.loadingStart();
      ApiService.service('GET', '/user/auth/basket/BSKT0001')
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.productList = data.result.basketProductList;
            this.rentalCount = data.result.rentalCount;
            this.purchaseCount = data.result.purchaseCount;
            this.deliveryCount = data.result.deliveryCount;
            this.cponBannerUrl = data.result.cponBannerUrl;

            let index = 0;
            for (let prod in this.productList) {
              this.couponCheck[index] = false;
              index++;
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        })
        .finally(() => {
          this.$refs.progress.loadingEnd();
          this.hideAllTooltip();
        });
    },
    showCouponTooltip: function (divId) {
      let index = divId.substring(7);
      this.couponCheck[index] = true;

      document.getElementById(divId).getElementsByClassName('btnIco_tip')[0].click();
    },
    selectCoupon: function (selectedCoupon, index) {
      let paramObj = new Object();
      let request = new Object();
      let couponInfo = [];

      let obj = new Object();
      obj.couponId = selectedCoupon.couponId;
      obj.prodCode = this.productCode;
      couponInfo.push(obj);

      request.couponInfo = couponInfo;
      paramObj.request = request;
      paramObj.serviceType = 'app';

      ApiService.service('POST', '/user/auth/coupon', paramObj)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.couponPopFlag = false;
            this.hideTooltip(index);

            this.msg = COUPON_SELECT;
            this.messagePop = true;
            this.selectBasketList();
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    allCoupon: function (couponList, index) {
      let paramObj = new Object();
      let request = new Object();
      let couponInfo = [];

      for (let coupon of couponList) {
        let obj = new Object();
        obj.couponId = coupon.couponId;
        obj.prodCode = this.productCode;
        couponInfo.push(obj);
      }

      request.couponInfo = couponInfo;
      paramObj.request = request;
      paramObj.serviceType = 'app';

      ApiService.service('POST', '/user/auth/coupon', paramObj)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.couponPopFlag = false;
            this.hideTooltip(index);

            this.msg = couponList.length + ALL_COUPON_SELECT;
            this.messagePop = true;
            this.selectBasketList();
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    productDelete: function (result) {
      // test 용
      //this.productList.splice(index, 1);
      //let i = this.chkSub.indexOf(index);
      //this.chkSub.splice(i, 1);
      let paramObj = new Object();
      let request = new Object();
      let basketInfo = [];
      let obj = new Object();
      if (result.selectedOption != null) {
        obj.optionCode = result.selectedOption.colorCode;
      }
      obj.prodCode = result.productInfo.productDetail.internalProdCode;
      obj.basketId = result.basketId;
      basketInfo.push(obj);
      request.basketInfo = basketInfo;
      paramObj.request = request;
      paramObj.serviceType = 'app';

      this.deleteBasketList(paramObj);
    },
    productListDelete: function () {
      // test 용
      /**for (let i = 0; i < this.chkSub.length; i++) {
          for (let index = 0; index < this.productList.length; index++) {
            if (this.chkSub[i] == this.productList[index].productInfo.product.productIndex) {
              this.productList.splice(index, 1);
            }
          }
        }**/

      if (this.chkSub.length == 0) {
        this.msg = '삭제할 상품을 선택해주세요.';
        this.messagePop = true;
        return;
      }

      let paramObj = new Object();
      let request = new Object();
      let basketInfo = [];

      for (let i of this.chkSub) {
        let product = this.productList[i];

        let obj = new Object();
        if (product.selectedOption != null) {
          obj.optionCode = product.selectedOption.colorCode;
        }
        obj.prodCode = product.productInfo.productDetail.internalProdCode;
        obj.basketId = product.basketId;
        basketInfo.push(obj);
      }

      request.basketInfo = basketInfo;
      paramObj.request = request;
      paramObj.serviceType = 'app';

      this.deleteBasketList(paramObj);

      this.chkSub = [];
    },
    optionPopupOpen: function (productObj) {
      $('body').addClass('popOn');
      this.productInfo = productObj;
      this.optionPopFlag = true;
    },
    optionPopupClose: function () {
      this.optionPopFlag = false;
    },
    optionSelect: function (optionResult) {
      let paramObj = new Object();
      let request = new Object();
      let basketInfo = [];

      for (let option of optionResult) {
        if (option != null) {
          if (option.flag == 'color') {
            let obj = new Object();
            obj.prodCode = this.productInfo.productInfo.productDetail.internalProdCode;
            obj.basketId = this.productInfo.basketId;
            obj.optionCode = option.value;
            basketInfo.push(obj);
          } else {
            let obj = new Object();
            obj.prodCode = option.value;
            obj.basketId = this.productInfo.basketId;
            obj.optionCode = '';
            basketInfo.push(obj);
          }
        }
      }

      request.basketInfo = basketInfo;
      paramObj.request = request;
      paramObj.serviceType = 'app';

      ApiService.service('POST', '/user/auth/basket/modify', paramObj)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.msg = OPTION_UPDATE;
            this.messagePop = true;
            this.selectBasketList();
            this.optionPopFlag = false;
          } else {
            this.msg = data.error;
            this.messagePop = true;
            this.selectBasketList();
            this.optionPopFlag = false;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    couponPopupOpen: function (productCode, downLoadableCponCount, index) {
      this.couponCheck[index] = true;
      if (downLoadableCponCount > 0) {
        this.productCode = productCode;
        this.idx = index;
        this.couponPopFlag = true;
      } else {
        this.hideTooltip(index);
        document.getElementById('rentalBtn' + index).click();
      }
    },
    couponPopupClose: function () {
      this.couponPopFlag = false;
      this.couponCheck[this.idx] = true;
      this.hideTooltip(this.idx);
    },
    hideTooltip: function (index) {
      // 툴팁 단건 삭제
      let tooltip = document.getElementsByClassName('tooltip');
      tooltip[index].getElementsByClassName('btnIco_close')[0].click();
    },
    hideAllTooltip: function () {
      // 툴팁 전체 삭제
      let tooltip = document.getElementsByClassName('tooltip');
      for (let i = 0; i < tooltip.length; i++) {
        tooltip[i].getElementsByClassName('btnIco_close')[0].click();
      }
    },
    getConvertPrice: function (value) {
      return convertPrice(value);
    },
    goProductDetail: function (productCode) {
      this.$router.push({ name: 'productDetail', params: { idx: productCode } });
    },
    checkOption: function (productInfo) {
      let result = true;
      // 렌탈기간 개수 여부
      let rentalPeriod = productInfo.productOptions.rentalPeriod.length;
      let color = productInfo.productColors.length;
      let option1 = productInfo.productOptions.productOption1.length;
      let option2 = productInfo.productOptions.productOption2.length;
      let option3 = productInfo.productOptions.productOption3.length;
      let checkType = productInfo.productOptions.checkType.length;
      let instType = productInfo.productOptions.instType.length;

      if (rentalPeriod <= 1 && color <= 1 && option1 <= 1 && option2 <= 1 && option3 <= 1 && checkType <= 1 && instType <= 1) {
        result = false;
      }

      return result;
    },
    deleteBasketList: function (paramObj) {
      ApiService.service('DELETE', '/user/auth/basket', paramObj)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.msg = DELETE_COMPLETE;
            this.messagePop = true;
            this.selectBasketList();
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    goRental: function (paramObj, index) {
      this.$router.push({
        name: 'memberMain',
        params: {
          productCode: paramObj.productInfo.product.productIndex,
          internalProdCode: paramObj.selectedOption.internalProdCode,
          productColors: paramObj.selectedOption.colorCode,
          order2_checkType: paramObj.selectedOption.checkType,
          order2_instType: paramObj.selectedOption.instType,
        },
      });
    },
    checkBoxWork: function () {
      let prodCount = 0;
      for (let i in this.chkSub) {
        prodCount++;
      }

      if (prodCount == this.productList.length) {
        this.chkAllFlag = true;
        this.chkAll = true;
      } else {
        this.chkAllFlag = false;
        this.chkAll = false;
      }
    },
    isOptionsExist: function (productInfo) {
      let result = false;
      let color = productInfo.productColors.length;
      let option1 = productInfo.productOptions.productOption1.length;
      let option2 = productInfo.productOptions.productOption2.length;
      let option3 = productInfo.productOptions.productOption3.length;
      let checkType = productInfo.productOptions.checkType.length;
      let instType = productInfo.productOptions.instType.length;

      if (color > 0 || option1 > 0 || option2 > 0 || option3 > 0 || checkType > 0 || instType > 0) {
        result = true;
      }

      return result;
    },
  },
};
</script>
